import type { FaireProductEntity } from "../../entity_types/product";

export const p_sru5g2qxmv: FaireProductEntity = {
  token: "p_sru5g2qxmv",
  type: "product",
  name: "Happy Dots Exclamation Square Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ecaf2c411875075e1e03609fa63569444226991df5f4190e5e62a6d4136a1a0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c8c4b72fa7bba3d997b411b3c0a4d9061213b0e3c2a3cb8979c8e2829036f1f.png",
    "https://cdn.faire.com/fastly/6bddff0722ed7fd7acb133405875ea7072a1054f403b4fdaebba3488697ffe8c.jpeg",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/2a946dcff2a8df82a8a241b9e58d049bd5f3f33901093cd34a8e59781ee13a4d.jpeg",
  ],
  priceDollars: 9,
  description:
    "Big and chunky. It's how we like our desserts and this awesome square notepad. This is the guy you pull out when you need an extra sturdy surface for those big, chunky ideas.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:39.867Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
